<template>
	<div class='quiz-landing m-t-md'>
    <div class='quiz-container landing-container'>
      <h1>{{data.titel}}</h1>

      <div class='knd-intro m-b-lg' v-html="data.intro">
      </div>

      <div class='knd-btn knd-btn-default m-b-lg' v-on:click="startQuiz">Test je kennis</div>

      <div class='knd-intro__verantwoording m-b-lg'>
        <p>{{data.verantwoording}}</p>
      </div>

  </div>
  </div>
</template>

<script>
export default {

  name: 'index',

  data () {
    return {
      data: this.$store.state.data,
    }
  },

  methods: {
    startQuiz () {
      this.$store.dispatch('next');
    } 
  }
}
</script>
